import Select from 'react-select';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
} from 'reactstrap';

import { CustomReactSelectStyles } from 'pages/Products/styles/customStyles';

import { useSelector } from 'react-redux';
import ProductImageUpload from './ProductImageUpload';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import { ProductFormDetailsInterface, SelectOptions } from 'types/productTypes';
import { Dispatch } from 'redux';
import { RootState } from 'slices';
import styles from 'pages/Products/styles/products.module.css';
import {
  handleBlurDisplayVatPercentage,
  handleChangeDisplayVatPercentage,
  handleFocusDisplayVatPercentage,
  handleOnKeyDisplayVatPercentage,
} from 'pages/Products/ProductManagement/FormHandlers';
import { formatNumberWithCommasAnd2Decimals } from 'utils/maths/InputFormats';
import ProductTag from 'pages/Products/Tag';

const ProductGeneralInfo = ({
  dispatch,
  formik,
}: {
  dispatch: Dispatch;
  formik: FormikProps<ProductFormDetailsInterface>;
}) => {
  const { t } = useTranslation();
  const productFormState = useSelector((state: RootState) => state.Product);
  const layoutState = useSelector((state: RootState) => state.Layout);
  // const infoState = useSelector((state: RootState) => state.Info);
  // const { branchCodes } = infoState;
  const {
    // isEdit,
    // editStoreId,
    pageConfig,
    searchCategory,
    searchSuppliers,
    showAllValidateErrors,
    displayVatPercentage,
  } = productFormState.form;
  const { layoutModeType } = layoutState;
  const isDarkMode = layoutModeType === 'dark';
  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('ProductPage_General')}</h5>
      </CardHeader>
      <CardBody className={`${styles['card-body-pd']}`}>
        <Row>
          <Col lg={6}>
            {/* {isEdit && editStoreId && (
              <div className={`mb-3 row`}>
                <Label htmlFor="#" className="col-sm-3 col-form-label">
                  {t('Branch')} <span style={{ color: 'red' }}>*</span>
                </Label>
                <Col sm={9} className="d-flex align-items-center">
                  <div>
                    <span>
                      {t('Branch')}{' '}
                      {branchCodes.find((b) => b.storeId === editStoreId)?.code}
                    </span>
                  </div>
                </Col>
              </div>
            )} */}

            <div className="mb-3 row">
              <Label htmlFor="productName" className="col-sm-3 col-form-label">
                {t('ProductField_ItemName')}{' '}
                <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <Input
                  type="text"
                  className="form-control"
                  id="productName"
                  name="productName"
                  value={formik.values.productName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={255}
                  required
                />

                {(formik.touched.productName &&
                  formik.errors.productName &&
                  typeof formik.errors.productName === 'string') ||
                (formik.isValid === false &&
                  formik.errors.productName &&
                  showAllValidateErrors === true) ? (
                  <div className="text-danger">{formik.errors.productName}</div>
                ) : null}
              </Col>
            </div>

            <div
              className={`mb-3 row ${
                pageConfig.custom_item_code ? '' : styles['input-hidden']
              }`}
            >
              <Label htmlFor="productCode" className="col-sm-3 col-form-label">
                {t('ProductField_ItemID')}{' '}
                <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <Input
                  type="text"
                  className="form-control"
                  id="productCode"
                  name="productCode"
                  value={formik.values.productCode || ''}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required={pageConfig.custom_item_code}
                  maxLength={50}
                />
                {(formik.touched.productCode &&
                  formik.errors.productCode &&
                  typeof formik.errors.productCode === 'string') ||
                (formik.isValid === false &&
                  formik.errors.productCode &&
                  showAllValidateErrors === true) ? (
                  <div className={`text-danger `}>
                    {formik.errors.productCode}
                  </div>
                ) : null}
              </Col>
            </div>

            <div className="mb-3 row">
              <Label htmlFor="barcode" className="col-sm-3 col-form-label">
                {t('ProductField_BarcodeID')}
              </Label>
              <Col sm={9}>
                <Input
                  type="text"
                  className="form-control"
                  id="barcode"
                  name="barcode"
                  value={formik.values.barcode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={255}
                />
                {(formik.touched.barcode &&
                  formik.errors.barcode &&
                  typeof formik.errors.barcode === 'string') ||
                (formik.isValid === false &&
                  formik.errors.barcode &&
                  showAllValidateErrors === true) ? (
                  <div className={`text-danger `}>{formik.errors.barcode}</div>
                ) : null}
              </Col>
            </div>

            <div className=" row">
              <Label htmlFor="category" className="col-sm-3 col-form-label">
                {t('ProductField_Category')}{' '}
                <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <FormGroup key={1}>
                  <Select
                    styles={CustomReactSelectStyles(isDarkMode)}
                    id="category"
                    name="category"
                    data-testid="category_test"
                    options={searchCategory.productsCategoryOptions}
                    value={
                      formik.values.category
                        ? searchCategory.productsCategoryOptions
                            .flatMap((group: SelectOptions) => group.options)
                            .find(
                              (option: { value: string }) =>
                                option.value === formik.values.category
                            )
                        : null
                    }
                    onChange={(option: { value: string }) => {
                      formik
                        .setFieldValue('category', option?.value)
                        .then(() => formik.setFieldTouched('category', true));
                    }}
                    onBlur={() => {
                      formik.setFieldTouched('category', true);
                    }}
                    placeholder={t('ProductPage_PleaseSelect')}
                  />
                  {(formik.touched.category &&
                    formik.errors.category &&
                    typeof formik.errors.category === 'string') ||
                  (formik.isValid === false &&
                    formik.errors.category &&
                    showAllValidateErrors === true) ? (
                    <div className="text-danger">{formik.errors.category}</div>
                  ) : null}
                </FormGroup>
              </Col>
            </div>

            <div className="mb-3 row">
              <Label htmlFor="supplier" className="col-sm-3 col-form-label">
                {t('ProductField_Supplier')}
              </Label>
              <Col sm={9}>
                <FormGroup key={2}>
                  <Select
                    styles={CustomReactSelectStyles(isDarkMode)}
                    id="supplier"
                    name="supplier"
                    options={searchSuppliers.supplierOptions}
                    value={
                      formik.values.supplier
                        ? searchSuppliers.supplierOptions
                            .flatMap((group: SelectOptions) => group.options)
                            .find(
                              (option: { value: string }) =>
                                option.value === formik.values.supplier
                            )
                        : null
                    }
                    onChange={(option: { value: string }) => {
                      formik.setFieldValue('supplier', option?.value);
                      formik.setFieldTouched('supplier', true);
                    }}
                    onBlur={() => {
                      formik.setFieldTouched('supplier', true);
                    }}
                    placeholder={t('ProductPage_PleaseSelect')}
                  />
                  {formik.touched.supplier &&
                  formik.errors.supplier &&
                  typeof formik.errors.supplier === 'string' ? (
                    <div className="text-danger">{formik.errors.supplier}</div>
                  ) : null}
                </FormGroup>
              </Col>
            </div>

            <div className="mb-3 row">
              <Label
                htmlFor="productDetails"
                className="col-sm-3 col-form-label"
              >
                {t('ProductField_Description')}
              </Label>
              <Col sm={9}>
                <textarea
                  className="form-control"
                  id="productDetails"
                  name="productDetails"
                  value={formik.values.productDetails}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  rows={5}
                  maxLength={255}
                ></textarea>
                {formik.touched.productDetails &&
                formik.errors.productDetails &&
                typeof formik.errors.productDetails === 'string' ? (
                  <div className="text-danger">
                    {formik.errors.productDetails}
                  </div>
                ) : null}
              </Col>
            </div>

            <div className="mb-3 row">
              <Label htmlFor="vat" className="col-sm-3 col-form-label">
                {t('ProductField_Vat')}
              </Label>
              <Col sm={9} xs={8}>
                <div>
                  <Input
                    type="text"
                    className="form-control"
                    id="vat"
                    name="vat"
                    value={
                      displayVatPercentage === ''
                        ? formatNumberWithCommasAnd2Decimals(
                            formik.values.vat
                          ) + ' %'
                        : displayVatPercentage
                    }
                    onChange={(e) => {
                      handleChangeDisplayVatPercentage(e, formik, dispatch);
                    }}
                    onKeyUp={(e) => {
                      handleOnKeyDisplayVatPercentage(e, formik, dispatch);
                    }}
                    onBlur={(e) => {
                      handleBlurDisplayVatPercentage(e, formik, dispatch);
                    }}
                    onFocus={() => {
                      handleFocusDisplayVatPercentage(formik, dispatch);
                    }}
                  />
                </div>
              </Col>
              <Col sm={3} xs={4}>
                <div></div>
              </Col>
            </div>

            <ProductTag formik={formik} />
          </Col>

          <ProductImageUpload dispatch={dispatch} formik={formik} />
        </Row>
      </CardBody>
    </Card>
  );
};
export default ProductGeneralInfo;
